export const LINK_STAGE = {
  ALPHA: 'ALPHA',
  BETA: 'BETA',
  STABLE: 'STABLE',
};

export const LINK_STATUS = {
  PENDING_DEVICE_REGISTRATION: 'PENDING_DEVICE_REGISTRATION',
  PARTIALLY_REGISTERED: 'PARTIALLY_REGISTERED',
  FAIL: 'FAIL',
  PENDING: 'PENDING',
  INACTIVE: 'INACTIVE',
  UPDATING_ASSETS: 'UPDATING_ASSETS',
  UPDATING_TRANSACTIONS: 'UPDATING_TRANSACTIONS',
  ACTIVE: 'ACTIVE',
  RETRIES: 'RETRIES',
  REQUESTED: 'REQUESTED',
  UNAUTHORIZED: 'UNAUTHORIZED',
};

export const LINK_MODE = {
  MANUAL: 'MANUAL',
  AUTOMATIC: 'AUTOMATIC',
  CASH: 'CASH',
  EMAIL: 'EMAIL',
  READ_ONLY: 'READ_ONLY',
};

export const LINK_QUEUED_STATUS = {
  READY: 'READY',
  QUEUED: 'QUEUED',
  FAILED: 'FAILED',
};

export const PRE_LINK_STATUS = {
  REQUESTED: 'REQUESTED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const SYNC_LINK_STATUS_LIST = [
  { value: 'COMPLETED' },
  { value: 'IN_PROGRESS' },
  { value: 'PENDING' },
  { value: 'FAILED' },
];

export const LINK_STATUS_PENDING_ASSETS = ['PENDING', 'UPDATING_ASSETS'];
export const LINK_STATUS_PENDINGS = ['PENDING', 'UPDATING_ASSETS', 'UPDATING_TRANSACTIONS'];

export const LINK_ERRORS = {
  403: {
    actions: ['contact-us', 'cancel'],
  },
  418: {
    actions: ['contact-us', 'cancel'],
  },
  501: {
    actions: ['contact-us', 'cancel'],
  },
  503: {
    actions: ['try-later'],
  },
  RETRIES: {
    message: 'The maximum waiting time has elapsed, refresh the page or contact your administrator.',
    actions: ['retry', 'cancel'],
  },
  DEFAULT: {
    message: 'We could not update the link credentials. Please verify them and try again, or contact your administrator.',
    actions: ['retry', 'cancel'],
  },
};

// Maps a backend error `type` (ErrorCode enum name from openbanking-core) to a
// canonical message that IS registered as an i18n key (pt/es/en), so the error
// screen can show it translated to the user's language. The dashboard does not
// send X-User-Language, so backend messages arrive in English — this catalog is
// how known link errors get localized on the front. Unmapped types fall back to
// the real backend/connector message (e.g. COMMUNICATION_ERROR passthrough).
export const LINK_ERROR_TYPE_MESSAGES = {
  // Connector-level errors (pre_link.response.type). Their raw messages are
  // provider-specific and mixed-language (even curl errors), so we map the
  // stable `type` to a clean, translatable message instead of showing the raw text.
  COMMUNICATION_ERROR: 'We could not reach the institution. Please try again in a few moments.',
  INVALID_CREDENTIALS: 'The credentials provided are invalid. Please check them and try again.',
  SESSION_ALREADY_ACTIVE: 'There is already an active session at this institution. Please sign in to the bank again and retry.',
  FORBIDDEN: 'The institution denied access. Please try again in a few moments or contact support.',
  UNSUPPORTED_USER: 'This user requires two-factor authentication, which is not yet supported.',
  UNPROCESSABLE_ENTITY: 'The institution could not process this request. Please review your details and try again.',
  INTERNAL_ERROR: 'Something went wrong while connecting to the institution. Please try again.',
  // Backend business errors (openbanking-core ErrorCode enum).
  LINK_ALREADY_EXISTS: 'There is already a link created with the same credentials.',
  PRELINK_ALREADY_EXISTS: 'A link is already being registered with these credentials. Please wait for it to finish.',
  INSTITUTION_OFFLINE: 'The institution is currently offline. Please try again once it is back online.',
  INSTITUTION_NOT_ACTIVE: 'This institution is not enabled, so a link cannot be created for it.',
  INSTITUTION_NOT_ALLOWED: 'This institution is not allowed to perform this operation.',
  LINK_REQUEST_ERROR: 'We could not process your request. Try again in a few minutes, or contact us if it persists.',
  INTERNAL_AUTHENTICATION_ERROR: 'We could not authenticate with the institution. Please verify your credentials and try again.',
  TOKEN_REQUIRED_FOR_ACTION: 'A token is required to update this institution\'s credentials.',
};

export const LINK_ERROR_ACTION = {
  RETRY: 'retry',
  CANCEL: 'cancel',
  TRY_LATER: 'try-later',
  CONTACT_US: 'contact-us',
};

export const SYNC_LINK_STATUS = {
  REQUESTED: 'REQUESTED',
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
};

export const LINK_OTP_PROVIDER = {
  PROPRIETOR: 'PROPRIETOR',
  GOOGLE_AUTHENTICATOR: 'GOOGLE_AUTHENTICATOR',
};
